var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCentralTv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4A4A4A",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.256.418a1.2 1.2 0 00-1.783 0l-5.795 6.235a1.43 1.43 0 000 1.918 1.2 1.2 0 001.784 0l5.794-6.234c.492-.53.492-1.39 0-1.92z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.322 6.653L6.527.418a1.2 1.2 0 00-1.783 0 1.43 1.43 0 000 1.919l5.795 6.234c.492.53 1.29.53 1.783 0a1.431 1.431 0 000-1.918z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.544 26.841c-1.39 0-2.522-1.217-2.522-2.714V10.39c0-1.498 1.131-2.715 2.522-2.715h18.912c1.39 0 2.521 1.218 2.521 2.715v13.737c0 1.497-1.13 2.714-2.52 2.714H2.543zm.005-16.485c.002.002-.005.013-.005.034v13.737c0 .027.011.036.012.037l18.891-.004a.054.054 0 00.009-.033V10.39c0-.028-.012-.037-.013-.038l-18.894.004z"
  }))));
}
export default SvgCentralTv;